import {
  SearchFilterBase,
  SearchFilterType,
} from '@aibees/elephant/feature/search-filters/types';
import { Maybe } from '@aibees/shared/definition';
import { useMemo } from 'react';

export function useClosedFilters(
  parentFilter: Maybe<SearchFilterBase>,
  openItemField?: string
) {
  return useMemo(
    () =>
      parentFilter?.items?.filter(
        (x) =>
          x.field !== openItemField &&
          x.type !== SearchFilterType.APPLIED_FILTERS
      ),
    [parentFilter?.items, openItemField]
  );
}
